module.exports = __webpack_public_path__ + "img/icon-3.1ed66df2.png";